import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=cbdf60c8&scoped=true&"
import script from "./Project.vue?vue&type=script&lang=js&"
export * from "./Project.vue?vue&type=script&lang=js&"
import style0 from "./Project.vue?vue&type=style&index=0&id=cbdf60c8&lang=scss&scoped=true&"
import style1 from "./Project.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdf60c8",
  null
  
)

export default component.exports